/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsibleParties/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DataVaxiomRelationshipsList from 'DesignSystem/DataVaxiomRelationshipsList/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ResponsibleParties({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/Sections/ResponsibleParties"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let profilePatientPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'person._id',
})
  return (<React.Fragment
>
<div
  data-testid="ResponsibleParties.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1RXa9q': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1RXa9q': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-Z1RXa9q': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-4-Z1RXa9q': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Responsible Parties"
/>
</div>
<DataVaxiomRelationshipsList
  viewPath={`${viewPath}/DataVaxiomRelationshipsList`}
 data="profile_patient.person._id"
 to_person={profilePatientPersonIdValueData}
 role="RESPONSIBLE"
/>
{children}
</React.Fragment>)
}